// 国际化 - 从JSON文件加载
let i18nData = {}
let currentLang = 'us' // 默认语言

// App深度链接配置
const APP_WAKE_URL = 'https://app.dmimi.ai/tiktok/auth?action=open' // 唤醒App链接
const WEB_HOME_URL = 'https://test.dmimi.ai/auth/callback?action=open' // 网页版首页（兜底）

// Android intent:// 唤起所用的 App 包名
const ANDROID_APP_PACKAGE = 'com.cashback.dmimi'
// 唤起 App 的 host/path 与参数（与 https App Link 保持一致）
const APP_HOST_PATH = 'app.dmimi.ai/tiktok/auth'
const APP_QUERY = 'action=open'

// 构造 Android intent:// 链接
function buildIntentUrl(scheme, hostPath, query, fallbackUrl) {
  const intentBody = query ? `${hostPath}?${query}` : hostPath
  const parts = [
    `intent://${intentBody}#Intent`,
    `scheme=${scheme}`,
    `package=${ANDROID_APP_PACKAGE}`
  ]
  if (fallbackUrl) {
    parts.push(`S.browser_fallback_url=${encodeURIComponent(fallbackUrl)}`)
  }
  return `${parts.join(';')};end`
}

// Android 顺序唤起：优先 dmimi，失败再 https，最后兜底网页
function wakeAppAndroid(hostPath, query, webFallback) {
  const dmimiIntent = buildIntentUrl('dmimi', hostPath, query, null)
  const httpsIntent = buildIntentUrl('https', hostPath, query, webFallback)

  const start = Date.now()
  console.log('[App] Android 尝试 dmimi intent 唤起:', dmimiIntent)
  window.location.href = dmimiIntent

  setTimeout(() => {
    if (document.visibilityState === 'visible' && Date.now() - start < 1600) {
      console.log('[App] dmimi 未唤起，重试 https intent:', httpsIntent)
      window.location.href = httpsIntent
    }
  }, 1500)
}

function isAndroidDevice() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera || ''
  return /android/i.test(userAgent)
}

// API基础地址
const API_BASE_URL = '/api'

// 授权状态
let authorizeFinished = false

// 获取浏览器语言并设置初始语言（支持URL参数覆盖）
function getInitialLanguage() {
  // 1. 优先从URL获取lang参数
  const urlParams = new URLSearchParams(window.location.search)
  const urlLang = urlParams.get('lang')

  console.log('[国际化] URL参数:', Object.fromEntries(urlParams))
  console.log('[国际化] URL语言参数:', urlLang)

  if (urlLang && ['en', 'zh', 'id', 'vi'].includes(urlLang.toLowerCase())) {
    console.log('[国际化] 使用URL指定的语言:', urlLang.toLowerCase())
    return urlLang.toLowerCase()
  }

  // 2. 否则使用浏览器语言
  const browserLang = navigator.language || navigator.userLanguage
  const langCode = browserLang.split('-')[0].toLowerCase()

  console.log('[国际化] 浏览器语言:', browserLang, '-> 语言代码:', langCode)

  if (['en', 'zh', 'id', 'vi'].includes(langCode)) {
    return langCode
  }

  // 3. 默认使用印尼语
  console.log('[国际化] 使用默认语言: id')
  return 'id'
}

// 从JSON文件加载国际化数据
async function loadI18n(lang) {
  try {
    const response = await fetch(`/i18n/${lang}.json`)
    if (!response.ok) {
      throw new Error(`加载国际化文件失败: ${response.status}`)
    }
    const data = await response.json()
    console.log(`[国际化] 加载${lang}语言翻译数据:`, Object.keys(data).length, '个键值对')
    return data
  } catch (error) {
    console.warn(`加载${lang}语言国际化数据失败:`, error)
    return {}
  }
}

// 为所有元素应用国际化翻译
function applyI18n() {
  console.log('[国际化] 执行applyI18n，当前语言:', currentLang, '翻译键数量:', Object.keys(i18nData[currentLang] || {}).length)

  // 处理所有可能包含{{i18n:key}}标记的元素
  const allElements = document.querySelectorAll('.auth-success-page, .auth-success-page *')
  allElements.forEach(el => {
    // 处理包含HTML内容的元素的innerHTML
    const innerHTML = el.innerHTML
    if (innerHTML && innerHTML.includes('{{i18n:')) {
      // 使用更安全的方式：查找并替换每个{{i18n:key}}标记
      const newHTML = innerHTML.replace(/\{\{i18n:([^}]+)\}\}/g, (match, key) => {
        return i18nData[currentLang]?.[key] || key
      })
      el.innerHTML = newHTML
    }

    // 处理仅包含文本的元素的textContent
    const textContent = el.textContent
    if (textContent && textContent.includes('{{i18n:') && !innerHTML?.includes('{{i18n:')) {
      const newText = textContent.replace(/\{\{i18n:([^}]+)\}\}/g, (match, key) => {
        return i18nData[currentLang]?.[key] || key
      })
      el.textContent = newText
    }
  })
}

// 显示失败图片
function showFailImage() {
  const img = document.getElementById('authResultImg')
  if (img) img.src = '/fail.webp'
}

// 发送授权请求
async function sendAuthorizeRequest(code, state) {
  try {
    const response = await fetch(`${API_BASE_URL}/creator/showcase/authorize`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ code, state })
    })
    const data = await response.json()
    if (data.code === 200) {
      console.log('[授权] 授权请求成功')
    } else {
      console.warn('[授权] 授权请求返回非200:', data)
      showFailImage()
    }
  } catch (error) {
    console.error('[授权] 授权请求失败:', error)
    showFailImage()
  } finally {
    authorizeFinished = true
    setButtonLoading(false)
  }
}

// 设置按钮loading状态
function setButtonLoading(loading) {
  const btn = document.getElementById('openAppBtn')
  if (!btn) return
  if (loading) {
    btn.classList.add('loading')
    btn.disabled = true
  } else {
    btn.classList.remove('loading')
    btn.disabled = false
  }
}

function isMobileDevice() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera || ''

  return /android/i.test(userAgent) || (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream)
}

function redirectToWebHome(reason) {
  console.log('[App] 跳转网页版首页:', reason, WEB_HOME_URL)
  window.location.href = WEB_HOME_URL
}

function tryWakeApp(wakeUrl) {
  return new Promise((resolve) => {
    const start = Date.now()
    window.open(wakeUrl, '_blank')

    setTimeout(() => {
      resolve(Date.now() - start >= 1600)
    }, 1500)
  })
}

// 打开App
async function openApp() {
  if (!authorizeFinished) return

  if (!isMobileDevice()) {
    redirectToWebHome('检测到非移动端环境')
    return
  }

  // Android：优先 dmimi intent，失败再 https intent，最后兜底网页
  if (isAndroidDevice()) {
    wakeAppAndroid(APP_HOST_PATH, APP_QUERY, WEB_HOME_URL)
    return
  }

  // iOS：维持现有 https App Link 行为
  console.log('[App] 尝试唤起App:', APP_WAKE_URL)
  const opened = await tryWakeApp(APP_WAKE_URL)
  if (opened) {
    console.log('[App] App唤起成功:', APP_WAKE_URL)
    return
  }

  redirectToWebHome('DeepLink唤起失败')
}

// 初始化应用
async function init() {
  // 设置初始语言
  currentLang = getInitialLanguage()

  // 加载国际化数据
  i18nData[currentLang] = await loadI18n(currentLang)
  console.log('[国际化] 国际化数据加载完成:', Object.keys(i18nData[currentLang] || {}).length, '个键值对')

  // 等待DOM完全加载后应用国际化翻译
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      console.log('[国际化] DOM加载完成，开始应用国际化翻译...')
      applyI18n()
    })
  } else {
    console.log('[国际化] DOM已加载完成，直接应用国际化翻译...')
    applyI18n()
  }

  // 从URL获取TikTok回调参数
  const urlParams = new URLSearchParams(window.location.search)
  const code = urlParams.get('code')
  const state = urlParams.get('state')
  console.log('[授权] URL参数 code:', code)
  console.log('[授权] URL参数 state:', state)

  // 设置按钮loading，发起授权请求
  if (code && state) {
    setButtonLoading(true)
    sendAuthorizeRequest(code, state)
  } else {
    console.warn('[授权] URL缺少code或state参数')
    authorizeFinished = true
  }

  // 绑定打开App按钮事件（使用事件委托，支持动态生成的元素）
  document.addEventListener('click', function(e) {
    // 打开App主按钮
    const openAppBtn = e.target.closest('#openAppBtn')
    if (openAppBtn) {
      openApp()
      return
    }

    // 相似商品卡片按钮（动态生成，使用事件委托）
    const productCardBtn = e.target.closest('.product-card-btn')
    if (productCardBtn) {
      openApp()
      return
    }
  })
}

// DOM加载完成后启动应用
function startApp() {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init)
  } else {
    // DOM已加载完成，立即执行
    init()
  }
}

startApp()
